/**
 * Factory method for the Google Tag Manager configuration object
 *
 * @param {VueRouter} [router] - GTM module can will listen for and sync with events from a router instance.
 *
 * Settings:
 * - defer:             defaults to false. Script can be set to `defer` to increase
 *                      page-load-time at the cost of less accurate results (in case
 *                      visitor leaves before script is loaded, which is unlikely but
 *                      possible)
 * - enabled:           defaults to true. Plugin can be disabled by setting this to
 *                      false for Ex: enabled: !!GDPR_Cookie (optional)
 * - debug:             Whether or not display console logs debugs (optional)
 * - loadScript:        Whether or not to load the GTM Script (Helpful if you are
 *                      including GTM manually, but need the dataLayer functionality in
 *                      your components) (optional)
 * - vueRouter:         Pass the router instance to automatically sync with router (optional)
 * - trackOnNextTick:   Whether or not call trackView in Vue.nextTick
 */

export const getConfig = router => {
  return {
    id: "GTM-NRDC63K",
    defer: false,
    enabled: true,
    debug: true,
    loadScript: true,
    vueRouter: router,
    trackOnNextTick: false
  };
};
